/*
 * Project: bellcloud
 * File: apps/frontend/src/ui/components/icons/StatusIcons.tsx
 * Author: SWAN
 * Created: 2025-03-05
 * Description: 상태 아이콘 컴포넌트
 */

import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const IconStable: React.FC<IconProps> = ({ width = 12, height = 12, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_431_32432)">
      <path
        d="M4.5 6.00022L5.5 7.00022L7.5 5.00022M10 6.50022C10 9.00022 8.25 10.2502 6.17 10.9752C6.06108 11.0121 5.94277 11.0104 5.835 10.9702C3.75 10.2502 2 9.00022 2 6.50022V3.00022C2 2.86762 2.05268 2.74044 2.14645 2.64667C2.24021 2.5529 2.36739 2.50022 2.5 2.50022C3.5 2.50022 4.75 1.90022 5.62 1.14022C5.72593 1.04972 5.86068 1 6 1C6.13932 1 6.27407 1.04972 6.38 1.14022C7.255 1.90522 8.5 2.50022 9.5 2.50022C9.63261 2.50022 9.75979 2.5529 9.85355 2.64667C9.94732 2.74044 10 2.86762 10 3.00022V6.50022Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_431_32432">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconWarning: React.FC<IconProps> = ({ width = 12, height = 12, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6 4V6M6 8H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAlert: React.FC<IconProps> = ({ width = 12, height = 12, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.00501 4.50462V6.50306M6.00501 8.50151H6.01M10.8661 9.00112L6.86932 2.00655C6.78217 1.85278 6.65579 1.72487 6.50307 1.63588C6.35035 1.54689 6.17676 1.5 6.00001 1.5C5.82326 1.5 5.64967 1.54689 5.49695 1.63588C5.34423 1.72487 5.21785 1.85278 5.1307 2.00655L1.13389 9.00112C1.0458 9.15368 0.999612 9.32682 1 9.50299C1.00039 9.67916 1.04735 9.85209 1.13611 10.0043C1.22488 10.1564 1.35229 10.2824 1.50544 10.3695C1.65859 10.4565 1.83204 10.5015 2.00819 10.5H10.0018C10.1771 10.4998 10.3493 10.4535 10.5011 10.3657C10.6528 10.2779 10.7788 10.1518 10.8664 9.99991C10.954 9.84803 11 9.67579 11 9.50048C11 9.32517 10.9538 9.15295 10.8661 9.00112Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconEye: React.FC<IconProps> = ({ width = 16, height = 16, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconEyeOff: React.FC<IconProps> = ({ width = 16, height = 16, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.35 6.35C5.83377 6.86802 5.53709 7.5665 5.52301 8.29903C5.50892 9.03156 5.77852 9.74094 6.27447 10.2784C6.77043 10.8159 7.45463 11.1397 8.18545 11.183C8.91627 11.2262 9.63403 10.9855 10.19 10.51M4.02 4.03C2.52 5.02 1.4 6.5 1 8C1.64 10.39 3.9 13 8 13C9.06 13 10 12.83 10.82 12.53M6.5 3.11C6.99 3.03 7.49 3 8 3C12.1 3 14.36 5.61 15 8C14.75 8.93 14.29 9.83 13.66 10.62M1 1L15 15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCalib: React.FC<IconProps> = ({ width = 12, height = 12, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.5 7.99995V3.99995C10.4998 3.82459 10.4535 3.65236 10.3658 3.50053C10.278 3.34871 10.1519 3.22263 10 3.13495L6.5 1.13495C6.34798 1.04718 6.17554 1.00098 6 1.00098C5.82446 1.00098 5.65202 1.04718 5.5 1.13495L2 3.13495C1.84813 3.22263 1.72199 3.34871 1.63423 3.50053C1.54647 3.65236 1.50018 3.82459 1.5 3.99995V7.99995C1.50018 8.17531 1.54647 8.34755 1.63423 8.49937C1.72199 8.65119 1.84813 8.77727 2 8.86495L5.5 10.865C5.65202 10.9527 5.82446 10.9989 6 10.9989C6.17554 10.9989 6.34798 10.9527 6.5 10.865L10 8.86495C10.1519 8.77727 10.278 8.65119 10.3658 8.49937C10.4535 8.34755 10.4998 8.17531 10.5 7.99995Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7.99995C7.10457 7.99995 8 7.10452 8 5.99995C8 4.89538 7.10457 3.99995 6 3.99995C4.89543 3.99995 4 4.89538 4 5.99995C4 7.10452 4.89543 7.99995 6 7.99995Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
